export const FAN_REFERRAL_BADGES = [
  { id: "word_of_mouth", label: "Word of Mouth", threshold: 3 },
  { id: "hype_machine", label: "Hype Machine", threshold: 10 },
  { id: "community_builder", label: "Community Builder", threshold: 25 },
  { id: "the_megaphone", label: "The Megaphone", threshold: 50 },
  { id: "crowd_maker", label: "Crowd Maker", threshold: 100 },
  { id: "the_draw", label: "The Draw", threshold: 250 },
  { id: "gravity", label: "Gravity", threshold: 500 },
  { id: "founders_equal", label: "Founder's Equal", threshold: 1000 },
];

export function getFanReferralBadgeStates(total = 0) {
  const n = Math.max(0, Number(total) || 0);
  const nextUnmet = FAN_REFERRAL_BADGES.find((b) => n < b.threshold) || null;
  const badges = FAN_REFERRAL_BADGES.map((badge) => {
    let state = "locked";
    if (n >= badge.threshold) state = "earned";
    else if (nextUnmet && badge.id === nextUnmet.id) state = "current";
    return { ...badge, state };
  });
  return { count: n, badges, nextThreshold: nextUnmet?.threshold ?? null };
}
